import { all } from 'redux-saga/effects';

/** IMPORT SAGA */
import atendimentoPosto from './atendimentoPosto/sagas';
import operacaoradadmdadosfaturamentoseplag from './operacaoradadmdadosfaturamentoseplag/sagas';
import unidadeSaldoCota from './unidadeSaldoCota/sagas';
import saldoCotaOrgaoLista from './saldoCotaOrgaoLista/sagas';
import auditoriaParametros from './auditoriaParametros/sagas';
import perfil from './perfil/sagas';
import arqueacao from './arqueacao/sagas';
import auth from './auth/sagas';

import esqueciminhasenha from './esqueciminhasenha/sagas';
import operacaoabastecimento from './operacaoabastecimento/sagas';
import operacaoliberacaoremota from './operacaoliberacaoremota/sagas';
import operacaoprerecebimentolista from './operacaoprerecebimentolista/sagas';
import operacaonotafiscaldescargas from './operacaonotafiscaldescargas/sagas';
import operacaoconsultalogliberacaosiad from './operacaoconsultalogliberacaosiad/sagas';
import operacaoconsultaimpedimentos from './operacaoconsultaimpedimentos/sagas';
import operacaoextratodadoscapatnqpostos from './operacaoextratodadoscapatnqpostos/sagas';
import operacaopostocontrolesiad from './operacaopostocontrolesiad/sagas';
import operacaopostomanutencao from './operacaopostomanutencao/sagas';
import operacaopostomigragestoresfrentista from './operacaopostomigragestoresfrentista/sagas';
import operacaooperstatusterminais from './operacaooperstatusterminais/sagas';
import operacaoprerecebimento from './operacaoprerecebimento/sagas';
import operacaoimpedimentos from './operacaoimpedimentos/sagas';
import operacaoradaprovarprefatura from './operacaoradaprovarprefatura/sagas';
import operacaoafericaoveiculo from './operacaoafericaoveiculo/sagas';
import operacaoliberacaoremotaconsulta from './operacaoliberacaoremotaconsulta/sagas';
import operacaoradpesquisaprefaturagfo from './operacaoradpesquisaprefaturagfo/sagas';
import operacaoradpesquisaprefaturaunidata from './operacaoradpesquisaprefaturaunidata/sagas';
import operacaobloqueioveiculoprefaturas from './OperacaoBloqueioVeiculoPreFaturas/sagas';
import operacaobloqueioveiculoprefaturagerada from './OperacaoBloqueioVeiculoPreFaturaGerada/sagas';
import operacaobloqueioprefaturageradaitem from './operacaobloqueioprefaturageradaitem/sagas';
import cadastrousuariomaster from './cadastrousuariomaster/sagas';
import cadastrocondutor from './cadastrocondutor/sagas';
import cadastromarca from './cadastromarca/sagas';
import cadastroposto from './cadastroposto/sagas';
import cadastroterminal from './cadastroterminal/sagas';
import operacaoradadmdadosfaturamentounidata from './operacaoradadmdadosfaturamentounidata/sagas';
import organRegistration from './organRegistration/sagas';
import unityRegistration from './unityRegistration/sagas';
import vehicleRegistration from './vehicleRegistration/sagas';
import auditoria from './auditoria/sagas'
import auditoriaitem from './auditoriaItem/sagas'

import bico from './bico/sagas';
import centrocusto from './centrocusto/sagas';
import cercasvirtuais from './cercasVirtuais/sagas';
import comboio from './comboio/sagas';
import configuracaoalarmetanque from './configuracaoalarmetanque/sagas';
import contrato from './contrato/sagas';
import dialog from './dialog/sagas';
import drawer from './drawer/sagas';
import empresaveiculo from './empresaveiculo/sagas';
import estoqueproduto from './estoqueproduto/sagas';
import hooks from './hooks/sagas';
import language from './language/sagas';
import marcasveiculo from './marcasveiculo/sagas';
import medidor from './medidor/sagas';
import modeloveiculo from './modeloveiculo/sagas';
import motorista from './motorista/sagas';
import operacao from './operacao/sagas';

import operacaoestoqueposto from './operacaoestoqueposto/sagas';
import operacaoestoquetanque from './operacaoestoquetanque/sagas';
import operacaorecebimento from './operacaorecebimento/sagas';
import operacaotransferencia from './operacaotransferencia/sagas';
import operacaovazamento from './operacaovazamento/sagas';

import posto from './posto/sagas';
import produto from './produto/sagas';
import tanquefisico from './tanquefisico/sagas';
import tanquevirtual from './tanquevirtual/sagas';
import terminal from './terminal/sagas';
import user from './user/sagas';
import usuario from './usuario/sagas';
import veiculo from './veiculo/sagas';
import frentista from './frentista/sagas';
import orgao from './orgao/sagas';
import unidade from './unidade/sagas';
import postoplanejamento from './postoplanejamento/sagas';
import postoplanejamentoGpp from './postoPlanejamentoGpp/sagas'
import rateio from './rateio/sagas'

import operacaoradrelatoriopesquisaprefaturaunidata from './operacaoradrelatoriopesquisaprefaturaunidata/sagas';
import operacaoradprefaturabloqueioplacarelatorio from './operacaoradprefaturabloqueioplacarelatorio/sagas';
import operacaoveiculomanutencaounidata from './operacaoveiculomanutencaounidata/sagas';
import pleitoposto from './pleitoposto/sagas';
import pleitoveiculo from './pleitoveiculo/sagas'
import operacaocotadistriborgao from './operacaocotadistriborgao/sagas';
import operacaocotadistribunidade from './operacaocotadistribunidade/sagas';
import operacaocotadistribveiculo from './operacaocotadistribveiculo/sagas';
import pleitopostoanexo from './pleitopostoanexo/sagas'
import limiteAbastecimento from './limiteAbastecimento/sagas'
import turnoAcompanhamento from './turnoAcompanhamento/sagas'

export default function* rootSata() {
  return yield all([
    /** EXPORT SAGA */
atendimentoPosto,
    operacaoradadmdadosfaturamentoseplag,
    unidadeSaldoCota,
    saldoCotaOrgaoLista,
    auditoriaParametros,
    perfil,
    auth,
    esqueciminhasenha,
    operacaoabastecimento,
    operacaoliberacaoremota,
    operacaoprerecebimentolista,
    operacaonotafiscaldescargas,
    operacaoconsultalogliberacaosiad,
    operacaoconsultaimpedimentos,
    operacaoextratodadoscapatnqpostos,
    operacaopostocontrolesiad,
    operacaopostomanutencao,
    operacaopostomigragestoresfrentista,
    operacaovazamento,
    operacaooperstatusterminais,
    operacaoprerecebimento,
    operacaoimpedimentos,
    operacaoradaprovarprefatura,
    operacaoliberacaoremotaconsulta,
    operacaoradpesquisaprefaturagfo,
    operacaoradpesquisaprefaturaunidata,
    operacaobloqueioveiculoprefaturas,
    operacaobloqueioveiculoprefaturagerada,
    operacaobloqueioprefaturageradaitem,
    cadastrousuariomaster,
    cadastrocondutor,
    cadastromarca,
    cadastroposto,
    cadastroterminal,
    operacaoradadmdadosfaturamentounidata,
    organRegistration,
    unityRegistration,
    vehicleRegistration,
    auditoria,
    auditoriaitem,

    bico,
    drawer,
    language,
    medidor,
    produto,
    posto,
    comboio,
    dialog,
    terminal,
    motorista,
    empresaveiculo,
    estoqueproduto,
    hooks,
    user,
    modeloveiculo,
    operacao,

    operacaoestoqueposto,
    operacaoestoquetanque,
    operacaorecebimento,

    operacaotransferencia,
    marcasveiculo,
    centrocusto,
    cercasvirtuais,
    contrato,
    usuario,
    veiculo,
    tanquevirtual,
    tanquefisico,
    arqueacao,
    configuracaoalarmetanque,
    operacaoafericaoveiculo,
    frentista,
    orgao,
    unidade,
    postoplanejamento,
    postoplanejamentoGpp,

    operacaoradrelatoriopesquisaprefaturaunidata,
    operacaoradprefaturabloqueioplacarelatorio,
    operacaoveiculomanutencaounidata,

    rateio,
    pleitoposto,
    pleitoveiculo,
    operacaocotadistriborgao,
    operacaocotadistribunidade,
    operacaocotadistribveiculo,
    pleitopostoanexo,
    limiteAbastecimento,
    turnoAcompanhamento,

  ]);
}
